import { render, staticRenderFns } from "./PeopleUserappGrid.vue?vue&type=template&id=28acc422&"
import script from "./PeopleUserappGrid.vue?vue&type=script&lang=js&"
export * from "./PeopleUserappGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports